import { FlexBox, MagicBox } from "@brg/ui";
import { FC } from "react";
import { ReactComponent as CheckIcon } from "../../../assets/check.svg";
import { ReactComponent as CheckWhite } from "../../../assets/checkWhite.svg";
import { useController } from "react-hook-form";
import { AppTester } from "supporting";
import { BilingLabel, CheckboxRoot } from "../styles";

type CheckBoxProps = {
  name: string;
  label?: string;
  nowrap?: boolean;
};

const CheckboxField: FC<CheckBoxProps> = ({
  name,
  label,
  nowrap,
}) => {
  const {field: { value, onChange }} = useController({name});
  const isCGrave = AppTester.isCGRAVE();
  const isGeograffee = AppTester.isGeograffee();

  const onChangeDefault = (ev: any) => {
    onChange(!value);
  };

  const checked = !!value;

  return (
    <MagicBox onClick={onChangeDefault} pointer align="center" gx={16}>
      <CheckboxRoot checked={checked} isProjectPage>
        {checked && (
          <>
            {!isGeograffee && !isCGrave ? <CheckIcon /> : <CheckWhite />}
          </>
        )}
        <input defaultChecked={checked} type="checkbox" />
      </CheckboxRoot>
      <FlexBox width={"100%"} widthMobile={"100%"}>
        <BilingLabel nowrap={nowrap}>{label}</BilingLabel>
      </FlexBox>
    </MagicBox>
  );
};

export default CheckboxField;import { FlexBox, MagicBox } from "@brg/ui";
import { FC } from "react";
import { ReactComponent as CheckIcon } from "../../../assets/check.svg";
import { ReactComponent as CheckWhite } from "../../../assets/checkWhite.svg";
import { useController } from "react-hook-form";
import { AppTester } from "supporting";
import { BilingLabel, CheckboxRoot } from "../styles";

type CheckBoxProps = {
  name: string;
  label?: string;
  nowrap?: boolean;
};

const CheckboxField: FC<CheckBoxProps> = ({
  name,
  label,
  nowrap,
}) => {
  const {field: { value, onChange }} = useController({name});
  const isCGrave = AppTester.isCGRAVE();
  const isGeograffee = AppTester.isGeograffee();

  const onChangeDefault = (ev: any) => {
    onChange(!value);
  };

  const checked = !!value;

  return (
    <MagicBox onClick={onChangeDefault} pointer align="center" gx={16}>
      <CheckboxRoot checked={checked} isProjectPage>
        {checked && (
          <>
            {!isGeograffee && !isCGrave ? <CheckIcon /> : <CheckWhite />}
          </>
        )}
        <input defaultChecked={checked} type="checkbox" />
      </CheckboxRoot>
      <FlexBox width={"100%"} widthMobile={"100%"}>
        <BilingLabel nowrap={nowrap}>{label}</BilingLabel>
      </FlexBox>
    </MagicBox>
  );
};

export default CheckboxField;